<script setup lang="ts">
import IconButton from '@/uiKit/IconButton.vue'
import ToolTip from '@/uiKit/ToolTip.vue'
import ToolTipContent from '@/uiKit/ToolTipContent.vue'

defineProps<{
  reasoning: string
}>()
</script>

<template>
  <div class="flex size-7 min-w-7 items-center justify-center p-0.5">
    <ToolTip
      placement="top"
      :flip-options="{
        fallbackPlacements: ['top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end'],
      }"
      :offset="2"
    >
      <template #content>
        <ToolTipContent>
          <template #title>Reasoning</template>
          <template #body>{{ reasoning }}</template>
        </ToolTipContent>
      </template>
      <IconButton
        aria-label="Reasoning"
        icon="info"
        size="md"
        class="hover:cursor-default"
        variant="transparent"
      />
    </ToolTip>
  </div>
</template>
